module.exports = __webpack_public_path__ + "img/scheme-ladder.4b29eedf.jpg";